import MiniDrawer from "../../components/Drawer"
import useModuleAccess from "../../utils/useModuleAccess"
import ConditionalRenderAssistant from "../../components/KwikAssistant/conditional-render"

const CortexPage = () => {
    useModuleAccess("cortex")
    return (
        <MiniDrawer child={<ConditionalRenderAssistant page="knowledgeBases" />} />
    )
}

export default CortexPage
